import { Component } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [FormsModule, InputTextModule, ButtonModule, PasswordModule]
})
export class LoginComponent {

  username: string = '';
  password: string = '';

  constructor(private authService: AuthService, private router: Router) { }

  // Method to handle the login process
  login(): void {
    this.authService.login(this.username, this.password).subscribe({
      next: () => {
        // On success, navigate to a protected route
        this.router.navigate(['/']);
      },
      error: (err) => {
        // Handle login error, show message to the user
        console.error('Login failed', err);
      }
    });
  }
}